module.exports = __webpack_public_path__ + "static/media/logo-raiffeisen.db9ed729.svg";